module.exports = __webpack_public_path__ + "img/bt_title2.56ff9745.png";